const CategoryActionTypes = {
  FETCH_CATEGORIES_START: 'categories/fetchStart' as const,
  FETCH_CATEGORIES_SUCCESS: 'categories/fetchSuccess' as const,
  FETCH_CATEGORIES_FAILURE: 'categories/fetchFailure' as const
}

export default CategoryActionTypes
